import { cn } from '@lemonenergy/lemonpie-3'
import type { HTMLAttributes, ReactNode } from 'react'

import CircularLoading from '~/components/CircularLoading'

interface CentralizedContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export const CentralizedContainer = ({
  children,
  className,
  ...props
}: CentralizedContainerProps) => (
  <div
    className={cn(
      'flex flex-1 justify-center items-center h-full min-h-[70px] fg-disabled',
      className,
    )}
    {...props}
  >
    {children}
  </div>
)

const Loader = () => (
  <CentralizedContainer>
    <CircularLoading />
  </CentralizedContainer>
)

export default Loader
